import { type ImportType, type ImprovedImportType } from '@webapp/models/enums'

export const IMPORT_LOCATION_URL = '/api/locations/import'
export const IMPORT_SHIPPING_ADDRESS_URL = '/api/address/import'
export const IMPORT_DEPARTMENT_URL = '/api/departments/import'
export const IMPORT_USER_URL = '/api/user/import'
export const IMPORT_ROLE_URL = '/api/import/user-roles/'
export const IMPORT_PERMISSION_URL = '/api/import/user-permissions/'
export const IMPORT_APPROVER_URL = '/api/approval-routing/import'
export const IMPORT_APPROVAL_ROUTING_GROUP_URL = '/api/approval/groups/import'
export const IMPORT_ACCOUNT_URL = '/api/account-code/import'
export const IMPORT_BUDGET_URL = '/api/budget/import'
export const IMPORT_PLANNED_BUDGET_URL = '/api/planned-budget/import'
export const IMPORT_VENDOR_URL = '/api/vendor/import'
export const IMPORT_CATALOG_ITEM_URL = '/api/catalog/import'
export const IMPORT_CATALOG_PERMISSION_URL = '/api/department-tag/import'
export const IMPORT_BUDGET_CATEGORY_URL = '/api/budget-categories/import'
export const IMPORT_ACCOUNT_CODE_LINK_URL = '/api/account-code/import-links'

type ImportTypeEndpointMapType = {
  [key in ImportType]: string
}

export const IMPORT_TYPE_ENDPOINT_MAP: ImportTypeEndpointMapType = {
  LOCATION: IMPORT_LOCATION_URL,
  SHIPPING_ADDRESS: IMPORT_SHIPPING_ADDRESS_URL,
  DEPARTMENT: IMPORT_DEPARTMENT_URL,
  USER: IMPORT_USER_URL,
  ROLE: IMPORT_ROLE_URL,
  PERMISSION: IMPORT_PERMISSION_URL,
  APPROVER: IMPORT_APPROVER_URL,
  APPROVAL_ROUTING_GROUP: IMPORT_APPROVAL_ROUTING_GROUP_URL,
  APPROVAL_ROUTING_GROUP_WITH_ADVANCED_TRIGGERS:
    IMPORT_APPROVAL_ROUTING_GROUP_URL,
  ACCOUNT: IMPORT_ACCOUNT_URL,
  BUDGET: IMPORT_BUDGET_URL,
  PLANNED_BUDGET: IMPORT_PLANNED_BUDGET_URL,
  VENDOR: IMPORT_VENDOR_URL,
  CATALOG_ITEM: IMPORT_CATALOG_ITEM_URL,
  CATALOG_PERMISSION: IMPORT_CATALOG_PERMISSION_URL,
  BUDGET_CATEGORY: IMPORT_BUDGET_CATEGORY_URL,
  BUDGETS_SETUP: IMPORT_BUDGET_CATEGORY_URL,
  ACCOUNT_CODE_LINK: IMPORT_ACCOUNT_CODE_LINK_URL,
}

export const SAMPLE_DATA_LOCATION_URL = '/api/v3/locations/import-sample/'
export const SAMPLE_DATA_ADDRESS_URL = '/api/v3/addresses/import-sample/'
export const SAMPLE_DATA_DEPARTMENT_URL = '/api/v3/departments/import-sample/'

type ImprovedImportTypeSampleDataEndpointMapType = {
  [key in ImprovedImportType]: string
}

export const IMPORT_SAMPLE_DATA_TYPE_ENDPOINT_MAP: ImprovedImportTypeSampleDataEndpointMapType =
  {
    LOCATION: SAMPLE_DATA_LOCATION_URL,
    SHIPPING_ADDRESS: SAMPLE_DATA_ADDRESS_URL,
    DEPARTMENT: SAMPLE_DATA_DEPARTMENT_URL,
  }

export const IMPROVED_IMPORT_LOCATION_URL = '/api/v3/locations/import/'
export const IMPROVED_IMPORT_ADDRESS_URL = '/api/v3/addresses/import/'
export const IMPROVED_IMPORT_DEPARTMENT_URL = '/api/v3/departments/import/'

type ImprovedImportTypeEndpointMapType = {
  [key in ImprovedImportType]: string
}

export const IMPROVED_IMPORT_TYPE_ENDPOINT_MAP: ImprovedImportTypeEndpointMapType =
  {
    LOCATION: IMPROVED_IMPORT_LOCATION_URL,
    SHIPPING_ADDRESS: IMPROVED_IMPORT_ADDRESS_URL,
    DEPARTMENT: IMPROVED_IMPORT_DEPARTMENT_URL,
  }

export const LOCATION_CSV_TEMPLATE_URL =
  'https://d3ethvafj7nff0.cloudfront.net/common/csv_import_templates/Location%20Import.csv'
export const SHIPPING_ADDRESS_CSV_TEMPLATE_URL =
  'https://d3ethvafj7nff0.cloudfront.net/common/csv_import_templates/Shipping%20Address%20Import.csv'
export const DEPARTMENT_CSV_TEMPLATE_URL =
  'https://d3ethvafj7nff0.cloudfront.net/common/csv_import_templates/Department%20Import.csv'
export const USER_CSV_TEMPLATE_URL =
  'https://d3ethvafj7nff0.cloudfront.net/common/csv_import_templates/User%20Profile%20Import.csv'
// Gated, dynamic template that includes the Entity column when Multi-Entity is
// enabled (mirrors the role/catalog imports which also use the backend).
export const USER_PROFILE_CSV_TEMPLATE_ENDPOINT = '/api/import/template/users/'
export const ROLE_CSV_TEMPLATE_URL = '/api/import/template/user-roles/'
export const PERMISSION_CSV_TEMPLATE_URL =
  '/api/import/template/user-permissions/'
export const APPROVER_CSV_TEMPLATE_URL =
  'https://d3ethvafj7nff0.cloudfront.net/common/csv_import_templates/Approver%20Import.csv'
export const ACCOUNT_CSV_TEMPLATE_URL =
  'https://d3ethvafj7nff0.cloudfront.net/common/csv_import_templates/Account%20Code%20Import.csv'
export const BUDGET_CSV_TEMPLATE_URL =
  'https://d3ethvafj7nff0.cloudfront.net/common/csv_import_templates/Budget%20Import.csv'
export const PLANNED_BUDGET_CSV_TEMPLATE_URL =
  'https://d3ethvafj7nff0.cloudfront.net/common/csv_import_templates/Planned%20Budget%20Import.csv'
export const VENDOR_CSV_TEMPLATE_URL =
  'https://d3ethvafj7nff0.cloudfront.net/common/csv_import_templates/Vendor%20Import.csv'
export const CATALOG_ITEM_CSV_TEMPLATE_URL = '/api/import/template/catalog/'
export const CATALOG_PERMISSION_CSV_TEMPLATE_URL =
  'https://d3ethvafj7nff0.cloudfront.net/common/csv_import_templates/Catalog%20Permission%20Import.csv'
export const BUDGET_CATEGORY_CSV_TEMPLATE_URL =
  'https://d3ethvafj7nff0.cloudfront.net/common/csv_import_templates/Budget%20Category%20Import.csv'
export const ACCOUNT_CODE_LINK_CSV_TEMPLATE_URL =
  'https://d3ethvafj7nff0.cloudfront.net/common/csv_import_templates/Account%20Code%20Link%20Import.csv'

export const APPROVAL_GROUP_CSV_TEMPLATE_URL =
  'https://d3ethvafj7nff0.cloudfront.net/common/csv_import_templates/Approval%20Group%20Import.csv'
export const APPROVAL_GROUP_WITH_ADVANCED_TRIGGERS_CSV_TEMPLATE_URL =
  'https://d3ethvafj7nff0.cloudfront.net/common/csv_import_templates/Approval%20Group%20Import%20With%20Advanced%20Triggers.csv'
